// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UhMd","controls":"styles_controls___RTJ6","charLimit":"styles_charLimit__Fyncw","input":"styles_input__3T1Yb","send":"styles_send__1ZLdI"};